import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    campaign: {
      id: "",
      title: "",
      terms: "",
      prizes: []
    }
  },
  mutations: {
    setCampaign(state, campaign) {
      state.campaign = campaign;
    }
  },
  actions: {
  },
  modules: {
  }
})
